import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ENDPOINTS } from '../../endpoints/api-endpoints';
import { SharedService } from './shared.service';
import { SESSION_STORAGE_KEYS } from '../../types/types';

@Injectable({
  providedIn: 'root'
})
export class TranslatorService {

  private AZURE_API_KEY = ENDPOINTS.AZURE_SERVICE.AZURE_API_KEY;
  private REGION = ENDPOINTS.AZURE_SERVICE.REGION;
  public lanUpdates = new Subject()

  constructor(private http: HttpClient, private sharedService: SharedService) { }

  public get activateLanguage(){
    return this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.CURRENT_LANGUAGE) || 'en'
  }

  public get targetLanguage(){
    return this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.TARGET_LANGUAGE) || 'hi'
  }

  translateAPI(content: any[]) {
    const header = this.createHeadersForTranslateAPI();

    const textToTranslateArray: any[] = [];
    content.forEach(text => {
      textToTranslateArray.push({ 'Text': text });
    })

    if (textToTranslateArray.length === 0) {
      return
    }

    const params = this.createParamsForTranslate();

    return this.http.post(ENDPOINTS.AZURE_SERVICE.TRANSLATE, textToTranslateArray, { headers: header, params: params }).toPromise();
  }

  getAllTranslateSupportedLanguages() {
    return this.http.get(`${ENDPOINTS.AZURE_SERVICE.LANGUAGES}?api-version=3.0`);
  }
  private createHeadersForTranslateAPI(): HttpHeaders {
    return new HttpHeaders({
      'Ocp-Apim-Subscription-Key': this.AZURE_API_KEY,
      'Ocp-Apim-Subscription-Region': this.REGION,
      'Content-Type': 'application/json'
    });
  }

  private createParamsForTranslate(): HttpParams {
    return new HttpParams()
      .set('api-version', '3.0')
      .set('from', this.activateLanguage || 'en')
      .set('to', this.targetLanguage || 'hi');
  }

  async translateSection(content: any[]) {
    const result = await this.translateAPI(content) as any[]
    const updatedResult :any = []
    if(result?.length){
      result.forEach((data)=>{
        const text = data.translations[0].text
        updatedResult.push(text)
      })
    }
    return updatedResult
  }
}
